<template>
  <label
    class="font-size-12 grey--text w-100 mb-0"
    :class="{
      'text--darken-2': !disabled,
      'red--text': error,
    }"
    :data-testid="tid"
    >{{ text }}</label
  >
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    error: {
      type: Boolean,
      required: false,
    },
    tid: {
      type: String,
      required: false,
    },
  },
}
</script>
